export function mentionLinkResolver(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody === '~accountid:' || link.notLinkBody === '~') {
        return [
            schema.nodes.paragraph.createChecked({}, [schema.nodes.text.create({})]),
        ];
    }
    if (link.notLinkBody.startsWith('~')) {
        var mentionText = link.notLinkBody.substring(1);
        var id = context.conversion &&
            context.conversion.mentionConversion &&
            context.conversion.mentionConversion[mentionText]
            ? context.conversion.mentionConversion[mentionText]
            : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id,
            }),
        ];
    }
    return;
}
//# sourceMappingURL=mention-link.js.map